import { HttpBackend, HttpClient, HttpInterceptor } from "@angular/common/http";
import { Injectable, InjectionToken, Injector } from "@angular/core";
import { CustomInterceptorHandler } from "./custom-intercept";

export const TRANSLATE_HTTP_INTERCEPTORS = new InjectionToken<
  HttpInterceptor[]
>("TRANSLATE_HTTP_INTERCEPTORS");

@Injectable({
  providedIn: "root",
})
export class TranslateHttpClient extends HttpClient {
  constructor(backend: HttpBackend, injector: Injector) {
    super(
      new CustomInterceptorHandler(
        backend,
        injector,
        TRANSLATE_HTTP_INTERCEPTORS
      )
    );
  }
}
